var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 22c5.547 0 10-4.407 10-9.955S17.547 2 12 2m0 20c-5.548 0-10-4.407-10-9.955S6.452 2 12 2m0 20c2.314 0 3.732-2.957 4.262-6.596M12 22c-2.314 0-3.732-2.957-4.262-6.596M12 2c2.31 0 3.734 2.988 4.263 6.654M12 2C9.69 2 8.266 4.988 7.737 8.654m-4.487 0h4.487m0 0h8.526m-8.526 0a24.26 24.26 0 0 0 .001 6.75m8.525-6.75h4.487m-4.487 0a24.257 24.257 0 0 1-.001 6.75m-13.012 0h4.488m0 0h8.524m0 0h4.488"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLine);
export default __webpack_public_path__ + "static/media/web_line.94d2e396d46dd2c3fbfddbdc9613344f.svg";
export { ForwardRef as ReactComponent };